import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiRoutes} from '../../config/api-routes';
import {Observable} from 'rxjs';
import {LoginSuccessResponse} from '../shared/model/login-success-response';
import {ApplicationType} from '../shared/enums/enums';
import {ApplicationUrls} from '../shared/model/aplication-urls';
import {LoginRequest} from "../shared/model/login-request";
import {DeviceService} from "../shared/service/device.service";

@Injectable()
export class LoginService {
  constructor(private httpClient: HttpClient, private apiRoutes: ApiRoutes, private device: DeviceService) {}

  public login(username: string, password: string, keepMeLoggedIn: boolean): Observable<LoginSuccessResponse> {
    const payload: LoginRequest = {
      username, password, keepMeLoggedIn,
      osInfo: this.device.os,
      browserInfo: this.device.browser,
      browserTrustKey: this.device.deviceId,
    };

    return this.httpClient.post<LoginSuccessResponse>(this.apiRoutes.LOGIN, payload);
  }
    
  public getUrls(application: ApplicationType, culture: string) : Observable<ApplicationUrls> {
    return this.httpClient.get<ApplicationUrls>(`${this.apiRoutes.APPLICATIONS}/Urls?application=${application}&culture=${culture}`);
  }
}

